const translations = {
  "en": {
    "Reach Max.": "Reach Max."
  },
  "zh-tw": {
    "Reach Max.": "達到最大值"
  }
};

export default translations;
